<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("globalloyaltysettings") }}
      </div>
      <router-link class="btn-blue" to="global-loyalty-settings"
        >{{ $t("globalloyaltysettings") }} {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper" style="zoom:0.9;">
      <div class="new-border back rounded-10 pt-2 px-3 pb-0 mb-2 back">
        <div class="row align-items-end">
          <!-- Loyalty Program Name -->
          <div class="col-md-3 mb-3">
            <label class="form-label font-weight-semibold text-muted mb-1">
              Loyalty Program Name
            </label>
            <input
              v-model="ls_name"
              v-validate="'required'"
              type="text"
              placeholder="Enter loyalty program name"
              name="loyaltysettingname"
              id="loyaltysettingname"
              class="form-control form-control-sm"
            />
            <small
              v-if="submitted && errors.has('loyaltysettingname')"
              class="text-danger"
            >
              {{ errors.first("loyaltysettingname") }}
            </small>
          </div>

          <!-- Initial Amount -->
          <div class="col-md-1 mb-3">
            <label class="form-label font-weight-semibold text-muted mb-1">
              Initial Amount
            </label>
            <input
              v-model="lnitial_load"
              v-validate="'required|numeric'"
              type="number"
              placeholder="0.00"
              name="initialload"
              id="initialload"
              class="form-control form-control-sm text-right"
            />
            <small
              v-if="submitted && errors.has('initialload')"
              class="text-danger"
            >
              {{ errors.first("initialload") }}
            </small>
          </div>

          <!-- Expiry Section -->
          <div class="col-md-3 mb-3">
            <label class="form-label font-weight-semibold text-muted mb-1">
              Expiry Duration
            </label>
            <div class="d-flex">
              <b-form-select
                v-model="expiry_type"
                id="expiryArray"
                :plain="true"
                value-field="expiry_id"
                text-field="expiry_name"
                @input="onSelectLevel($event)"
                :options="expiryArray"
              >
                <template slot="first">
                  <option :value="null" disabled>-- Select Expiry --</option>
                </template>
              </b-form-select>

              <input
                v-model="expiry_value"
                v-validate="'required|numeric'"
                type="number"
                :disabled="!selectedExpiry['show_input']"
                :class="!selectedExpiry['show_input'] ? 'no_edit_allowed' : ''"
                class="form-control form-control-sm text-right flex-fill ml-3"
                placeholder="Value"
                name="expiryvalue"
                id="expiryvalue"
                style="width: 30%;"
              />
            </div>
            <small
              v-if="submitted && errors.has('expiryvalue')"
              class="text-danger"
            >
              {{ errors.first("expiryvalue") }}
            </small>
            <small
              v-else-if="submitted && expiry_rule.length == 0"
              class="text-danger"
            >
              Please select duration
            </small>
          </div>

          <!-- Checkboxes Section -->
          <div class="col-md-5 mb-4">
            <div class="d-flex flex-wrap align-items-center gap-4">
              <b-form-checkbox
                unchecked-value="N"
                v-model="visit_based_levels"
                value="Y"
                name="visit-based"
                class="j-checkbox mr-3"
                @change="onChangeVistBasedLevels($event)"
              >
                Visit Based
              </b-form-checkbox>

              <b-form-checkbox
                unchecked-value="N"
                v-model="amount_based_levels"
                value="Y"
                name="amount-based"
                class="j-checkbox mr-3"
                @change="onChangeAmountBasedLevels($event)"
              >
                Amount Based
              </b-form-checkbox>

              <b-form-checkbox
                v-model="ls_is_active"
                name="active"
                class="j-checkbox mr-2"
              >
                Active
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row px-3">
          <div class="levelText">Loyalty Levels</div>
        </div>

        <section class="row p-3">
          <table
            class="swc-report-table"
            border="1"
            style="table-layout: auto; background: white"
          >
            <thead>
              <tr>
                <th class=" p-1">
                  Level Name
                </th>

                <template v-if="visit_based_levels == 'Y'">
                  <th class=" p-1">
                    Visits
                  </th>
                  <th class=" p-1">
                    Within Days
                  </th>
                </template>
                <template v-if="amount_based_levels == 'Y'">
                  <th class=" p-1">
                    Amount Required
                  </th>
                  <th class=" p-1">
                    Within Days
                  </th>
                </template>
                <template v-else>
                  <th class=" p-1">
                    Points Required
                  </th>
                </template>
                <th class=" p-1">
                  Points Multiplier
                </th>
                <th class=" p-1">
                  Bonus Points
                </th>
                <th class=" p-1">
                  Active
                </th>
                <th class=" p-1" style="width: 80px">Action</th>
              </tr>
            </thead>
            <tbody v-if="loyalty_levels.length > 0">
              <tr v-for="(item, index) in loyalty_levels" :key="index">
                <td class="text-left p-0">
                  <div class="manual_bill_input">
                    <input
                      v-model="item.ll_name"
                      :id="'llname' + index"
                      v-validate="'required'"
                      placeholder="Level Name"
                      type="text"
                      name="loyaltylevelname"
                    />
                  </div>
                </td>
                <template v-if="visit_based_levels == 'Y'">
                  <td class="text-left p-0">
                    <div class="manual_bill_input">
                      <input
                        class="text-right"
                        v-model="item.visits"
                        v-validate="'required|numeric'"
                        placeholder="Visits"
                        type="number"
                        name="visits"
                        id="visits"
                      />
                    </div>
                  </td>
                  <td class="text-left p-0">
                    <div class="manual_bill_input">
                      <input
                        class="text-right"
                        v-model="item.visit_within_days"
                        v-validate="'required|numeric'"
                        placeholder="Within Days"
                        type="number"
                        name="visit_within_days"
                        id="visit_within_days"
                      />
                    </div>
                  </td>
                </template>
                <template v-if="amount_based_levels == 'Y'">
                  <td class="text-left p-0">
                    <div class="manual_bill_input">
                      <input
                        class="text-right"
                        v-model="item.points_required"
                        v-validate="'required|numeric'"
                        placeholder="Amount Required"
                        type="number"
                        name="pointrquired"
                        id="pointrquired"
                      />
                    </div>
                  </td>
                  <td class="text-left p-0">
                    <div class="manual_bill_input">
                      <input
                        class="text-right"
                        v-model="item.visit_within_days"
                        v-validate="'required|numeric'"
                        placeholder="Within Days"
                        type="number"
                        name="visit_within_days"
                        id="visit_within_days"
                      />
                    </div>
                  </td>
                </template>
                <template v-else>
                  <td class="text-left p-0">
                    <div class="manual_bill_input">
                      <input
                        class="text-right"
                        v-model="item.points_required"
                        v-validate="'required|numeric'"
                        placeholder="Points Required"
                        type="number"
                        name="pointrquired"
                        id="pointrquired"
                      />
                    </div>
                  </td>
                </template>
                <td class="text-left p-0">
                  <div class="manual_bill_input">
                    <input
                      class="text-right"
                      v-model="item.multiple_points"
                      v-validate="'required'"
                      placeholder="Multiple Points"
                      type="number"
                      name="multiplepointsrquired"
                      id="multiplepointsrquired"
                    />
                  </div>
                </td>
                <td class="text-left p-0">
                  <div class="manual_bill_input">
                    <input
                      class="text-right"
                      v-model="item.bonus_points"
                      v-validate="'required|numeric'"
                      placeholder="Bonus Points"
                      type="number"
                      name="bonuspoint"
                      id="bonuspoint"
                    />
                  </div>
                </td>
                <td class="text-center p-0">
                  <b-form-checkbox
                    v-model="item.ll_is_active"
                    name="check-button"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                </td>
                <td>
                  <div
                    class="icon-sm-minus blue-icon ml-2 btn"
                    @click.prevent.stop="removeLoyaltySettings(index)"
                  ></div>
                </td>
              </tr>
              <tr class="">
                <td colspan="12">
                  <div
                    class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                  >
                    <button
                      @click.prevent.stop="addLoyaltySettings()"
                      class="btn-transparent add-more-button addBtn_multi"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="24"
                        width="24"
                      />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr class="">
                <td colspan="12"></td>
              </tr>
              <tr class="">
                <td colspan="12">
                  <div
                    class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                  >
                    <button
                      @click.prevent.stop="addLoyaltySettings()"
                      class="btn-transparent add-more-button addBtn_multi"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="24"
                        width="24"
                      />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        <div
          class="section-title mt-4 mb-4 d-flex justify-content-between section-border section-border"
          style="padding: 6px; align-items: center"
          v-b-toggle.additionalOffers
        >
          <span class="fs">
            Additional Benefits
          </span>

          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>

        <b-collapse
          id="additionalOffers"
          class="mt-2"
          v-model="sectionCollapse.additionalOffers"
        >
          <section class="offers-section">
            <div class="card border-0 shadow-sm p-1 rounded-lg">
              <!-- Header Buttons -->
              <div
                class="d-flex align-items-center justify-content-between mb-3"
              >
                <h5 class="fw-semibold mb-0">Loyalty Program Offers</h5>
                <div>
                  <button
                    class="btn btn-outline-primary btn-sm"
                    @click="addVisitOfferToSelected"
                  >
                    + Add Visit Voucher
                  </button>
                  <button
                    class="btn btn-outline-primary btn-sm ms-2"
                    @click="addExclusiveOfferToSelected"
                  >
                    + Add Exclusive Offer
                  </button>
                  <button
                    class="btn btn-outline-primary btn-sm ms-2"
                    @click="addPaydayOffers"
                  >
                    + Add Payday Offer
                  </button>
                  <button
                    class="btn btn-outline-primary btn-sm ms-2"
                    @click="addBirthdayTreat"
                  >
                    + Add Birthday Treat
                  </button>
                </div>
              </div>

              <!-- Level Selector -->
              <div
                class="level-pills mb-4 d-flex flex-nowrap overflow-auto pb-2"
              >
                <button
                  v-for="(level, idx) in loyalty_levels"
                  :key="'pill-' + idx"
                  class="btn btn-sm me-2 minWidth"
                  :class="{
                    'btn-primary': selectedLevelIndex == idx,
                    'btn-outline-secondary': selectedLevelIndex != idx
                  }"
                  @click="selectedLevelIndex = idx"
                >
                  {{ level.ll_name || "Level " + (idx + 1) }}
                </button>
              </div>

              <!-- ==================== VISIT BASED VOUCHERS ==================== -->
              <div class="offer-block rounded-lg mb-1">
                <div class="row no-gutters">
                  <div
                    class="col-md-3 d-flex align-items-center justify-content-center border-end bg-light"
                  >
                    <div class="text-center fw-semibold text-muted px-2 py-3">
                      Visit-based Vouchers
                    </div>
                  </div>
                  <div class="col-md-9 p-3">
                    <table class="table table-sm align-middle mb-0">
                      <thead
                        class="table-light"
                        v-if="currentLevel.visitVouchers.length"
                      >
                        <tr>
                          <th style="width: 15%">Visits</th>
                          <th style="width: 20%">Type</th>
                          <th style="width: 25%">E-coupon / Multiplier</th>
                          <th style="width: 15%">Validity (Days)</th>
                          <th style="width: 5%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(v, vi) in currentLevel.visitVouchers"
                          :key="'visit-' + vi"
                          class="table-loyalty"
                        >
                          <td>
                            <input
                              v-model="v.no_of_visits"
                              type="number"
                              class="form-control form-control-sm"
                              placeholder="Visits"
                            />
                          </td>
                          <td>
                            <b-form-select
                              required
                              v-model="v.benefit_type_id"
                              :plain="true"
                              value-field="type_id"
                              text-field="type_name"
                              @input="onSelectBenefitType($event, v)"
                              :options="benefitTypes"
                            >
                              <template slot="first">
                                <option :value="null" disabled
                                  >-- Select Type --</option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="v.benefit_type_id == 1">
                              <b-form-select
                                required
                                v-model="v.os_id"
                                :plain="true"
                                value-field="os_id"
                                text-field="offer_title"
                                :options="voucherOptions"
                              >
                                <template slot="first">
                                  <option :value="null" disabled
                                    >-- Select E-coupon --</option
                                  >
                                </template>
                              </b-form-select>
                            </template>
                            <template v-else>
                              <input
                                v-model="v.pts_multplier"
                                type="number"
                                class="form-control form-control-sm"
                                placeholder="Pts. Multiplier"
                              />
                            </template>
                          </td>
                          <td>
                            <input
                              v-if="v.benefit_type_id == 1"
                              v-model="v.voucher_validity_in_days"
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="Validity"
                            />
                          </td>
                          <td class="text-center">
                            <div
                              class="icon-sm-minus blue-icon btn"
                              @click.prevent.stop="
                                removeVisitOfferFromSelected(vi)
                              "
                            ></div>
                          </td>
                        </tr>
                        <tr
                          v-if="currentLevel.visitVouchers.length === 0"
                          class="table-loyalty"
                        >
                          <td
                            colspan="5"
                            class="text-muted small text-center py-2"
                          >
                            No visit vouchers defined for this level.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- ==================== PAYDAY OFFERS ==================== -->
              <div class="offer-block rounded-lg mb-1">
                <div class="row no-gutters">
                  <div
                    class="col-md-3 d-flex align-items-center justify-content-center border-end bg-light"
                  >
                    <div class="text-center fw-semibold text-muted px-2 py-3">
                      Payday Offers
                    </div>
                  </div>
                  <div class="col-md-9 p-3">
                    <table class="table table-sm align-middle mb-0">
                      <thead
                        class="table-light"
                        v-if="currentLevel.payday.length"
                      >
                        <tr>
                          <th style="width: 15%">Days</th>
                          <th style="width: 20%">Type</th>
                          <th style="width: 25%">E-coupon / Multiplier</th>
                          <th style="width: 15%">Validity (Days)</th>
                          <th style="width: 5%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(p, pi) in currentLevel.payday"
                          :key="'payday-' + pi"
                          class="table-loyalty"
                        >
                          <td>
                            <input
                              v-model="p.payday_days"
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="eg.(25,26)"
                            />
                          </td>
                          <td>
                            <b-form-select
                              v-model="p.benefit_type_id"
                              :plain="true"
                              value-field="type_id"
                              text-field="type_name"
                              :options="benefitTypes"
                              @input="onSelectBenefitType($event, p)"
                            >
                              <template slot="first">
                                <option :value="null" disabled
                                  >-- Select Type --</option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="p.benefit_type_id == 1">
                              <b-form-select
                                v-model="p.os_id"
                                :plain="true"
                                value-field="os_id"
                                text-field="offer_title"
                                :options="voucherOptions"
                              >
                                <template slot="first">
                                  <option :value="null" disabled
                                    >-- Select E-coupon --</option
                                  >
                                </template>
                              </b-form-select>
                            </template>
                            <template v-else>
                              <input
                                v-model="p.pts_multplier"
                                type="number"
                                class="form-control form-control-sm"
                                placeholder="Pts. Multiplier"
                              />
                            </template>
                          </td>
                          <td>
                            <input
                              v-if="p.benefit_type_id == 1"
                              v-model="p.voucher_validity_in_days"
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="Validity"
                            />
                          </td>
                          <td class="text-center">
                            <div
                              class="icon-sm-minus blue-icon btn"
                              @click.prevent.stop="
                                removePaydayOfferFromSelected(pi)
                              "
                            ></div>
                          </td>
                        </tr>
                        <tr
                          v-if="currentLevel.payday.length === 0"
                          class="table-loyalty"
                        >
                          <td
                            colspan="4"
                            class="text-muted small text-center py-2"
                          >
                            No payday offers defined for this level.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- ==================== EXCLUSIVE OFFERS ==================== -->
              <div class="offer-block rounded-lg mb-1">
                <div class="row no-gutters">
                  <div
                    class="col-md-3 d-flex align-items-center justify-content-center border-end bg-light"
                  >
                    <div class="text-center fw-semibold text-muted px-2 py-3">
                      Exclusive Offers
                    </div>
                  </div>
                  <div class="col-md-9 p-3">
                    <table class="table table-sm align-middle mb-0">
                      <thead
                        class="table-light"
                        v-if="currentLevel.exclusiveOffers.length"
                      >
                        <tr>
                          <th>Offer</th>
                          <th>Validity (Days)</th>
                          <th style="width: 5%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(e, ei) in currentLevel.exclusiveOffers"
                          :key="'exclusive-' + ei"
                          class="table-loyalty"
                        >
                          <td>
                            <b-form-select
                              v-model="e.os_id"
                              :plain="true"
                              value-field="os_id"
                              text-field="offer_title"
                              :options="voucherOptions"
                            >
                              <template slot="first">
                                <option :value="null" disabled
                                  >-- Select Offer --</option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <input
                              v-model="e.voucher_validity_in_days"
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="Validity"
                            />
                          </td>
                          <td class="text-center">
                            <div
                              class="icon-sm-minus blue-icon btn"
                              @click.prevent.stop="
                                removeExclusiveOfferFromSelected(ei)
                              "
                            ></div>
                          </td>
                        </tr>
                        <tr
                          v-if="currentLevel.exclusiveOffers.length === 0"
                          class="table-loyalty"
                        >
                          <td
                            colspan="3"
                            class="text-muted small text-center py-2"
                          >
                            No exclusive offers defined for this level.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- ==================== BIRTHDAY TREATS ==================== -->
              <div class="offer-block rounded-lg">
                <div class="row no-gutters">
                  <div
                    class="col-md-3 d-flex align-items-center justify-content-center border-end bg-light"
                  >
                    <div class="text-center fw-semibold text-muted px-2 py-3">
                      Birthday Treats
                    </div>
                  </div>
                  <div class="col-md-9 p-3">
                    <table class="table table-sm align-middle mb-0">
                      <thead
                        class="table-light"
                        v-if="currentLevel.birthday.length"
                      >
                        <tr>
                          <th>Offer</th>
                          <th>Validity (Days)</th>
                          <th style="width: 5%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(b, bi) in currentLevel.birthday"
                          :key="'birthday-' + bi"
                          class="table-loyalty"
                        >
                          <td>
                            <b-form-select
                              v-model="b.os_id"
                              :plain="true"
                              value-field="os_id"
                              text-field="offer_title"
                              :options="voucherOptions"
                            >
                              <template slot="first">
                                <option :value="null" disabled
                                  >-- Select Offer --</option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <input
                              v-model="b.voucher_validity_in_days"
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="Validity"
                            />
                          </td>
                          <td class="text-center">
                            <div
                              class="icon-sm-minus blue-icon btn"
                              @click.prevent.stop="
                                removeBirthdayTreatFromSelected(bi)
                              "
                            ></div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" v-if="currentLevel.birthday.length">
                            <span class="smallNote">
                              Note: Birthday Treat is applicable only to
                              customers who have been registered for at least
                              one month prior to their birthday.</span
                            >
                          </td>
                        </tr>
                        <tr
                          v-if="currentLevel.birthday.length === 0"
                          class="table-loyalty"
                        >
                          <td
                            colspan="3"
                            class="text-muted small text-center py-2"
                          >
                            No birthday treats defined for this level.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </b-collapse>
      </div>

      <section>
        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button @click.prevent.stop="resetHandler" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="global-loyalty-settings"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      sectionCollapse: {
        additionalOffers: false
      },
      btenable: false,
      submitted: false,
      ls_id: null,
      ls_name: "",
      expiry_rule: "",
      expiry_value: "",
      lnitial_load: "",
      ls_is_active: true,
      expiry_type: 3,
      visit_based_levels: "N",
      amount_based_levels: "N",
      selectedExpiry: {
        expiry_id: 3,
        expiry_name: "Year",
        show_input: true
      },
      expiryArray: [
        {
          expiry_id: 1,
          expiry_name: "Day",
          show_input: true
        },
        {
          expiry_id: 2,
          expiry_name: "Month",
          show_input: true
        },
        {
          expiry_id: 3,
          expiry_name: "Year",
          show_input: true
        },
        {
          expiry_id: 4,
          expiry_name: "Year End",
          show_input: false
        },
        {
          expiry_id: 5,
          expiry_name: "No Expiry",
          show_input: false
        }
      ],
      benefitTypes: [
        {
          type_id: 1,
          type_name: "E-coupon"
        },
        {
          type_id: 2,
          type_name: "Pts. Multiplier"
        }
      ],
      additionalOfferObj: {
        benefit_section_type_id: 1,
        visits: null,
        benefit_type_id: 1,
        os_id: null,
        voucher_validity_in_days: null,
        pts_multplier: null,
        payday_days: null
      },
      loyalty_levels: [
        {
          ll_name: `Level 1`,
          visits: null,
          visit_within_days: null,
          points_required: null,
          multiple_points: null,
          bonus_points: null,
          ll_is_active: true,
          visit_based_levels: "N",
          amount_based_levels: "N",
          visitVouchers: [],
          exclusiveOffers: [],
          birthday: [],
          payday: []
        }
      ],
      levels: ["Day", "Month", "Year"],
      voucherOptions: [
        { id: 1, name: "Popcorn Voucher" },
        { id: 2, name: "Drink Voucher" },
        { id: 3, name: "Free Ticket" },
        { id: 4, name: "Combo Voucher" }
      ],
      selectedLevelIndex: 0
    };
  },
  computed: {
    currentLevel() {
      console.log(
        "this.loyalty_levels[this.selectedLevelIndex]",
        this.loyalty_levels[this.selectedLevelIndex]
      );
      return this.loyalty_levels[this.selectedLevelIndex] || null;
    }
  },
  watch: {
    loyalty_levels(newLevels) {
      if (this.selectedLevelIndex >= newLevels.length) {
        this.selectedLevelIndex = Math.max(0, newLevels.length - 1);
      }
    }
  },
  mounted() {},
  beforeMount() {
    const { ls_id } = this.$route.query;
    if (ls_id) {
      this.getGloballoyaltysettingsBYID(ls_id);
    }
    this.GetDynamicVouchers();
  },
  methods: {
    onSelectBenefitType(event, levelObj) {
      let benefitType = this.benefitTypes.filter(x => x.type_id == event);
      if (benefitType && benefitType.length) {
        levelObj["benefit_type_name"] = benefitType[0]["type_name"];
      }
    },
    resetHandler: function() {
      this.submitted = false;
      this.visit_based_levels = "N";
      this.amount_based_levels = "N";
      this.ls_name = "";
      this.expiry_rule = "";
      this.expiry_value = "";
      this.lnitial_load = "";
      this.ls_is_active = true;
      this.loyalty_levels = [
        {
          ll_name: "Level " + 1,
          visits: null,
          visit_within_days: null,
          points_required: null,
          multiple_points: null,
          bonus_points: null,
          ll_is_active: true,
          visit_based_levels: "N",
          amount_based_levels: "N",
          visitVouchers: [],
          exclusiveOffers: [],
          birthday: [],
          payday: []
        }
      ];
    },
    // Offers (for selected level)
    addVisitOfferToSelected() {
      if (!this.currentLevel) return;
      this.currentLevel.visitVouchers.push({
        benefit_section_type_id: 1,
        benefit_section_name: "Visit Benefits",
        no_of_visits: null,
        benefit_type_id: 1,
        benefit_type_name: "E-coupon",
        os_id: null,
        voucher_validity_in_days: null,
        pts_multplier: null,
        payday_days: null
      });
    },
    removeVisitOfferFromSelected(idx) {
      if (!this.currentLevel) return;
      this.currentLevel.visitVouchers.splice(idx, 1);
    },
    addExclusiveOfferToSelected() {
      if (!this.currentLevel) return;
      this.currentLevel.exclusiveOffers.push({
        benefit_section_type_id: 2,
        benefit_section_name: "Exclusive Benefits",
        visits: null,
        benefit_type_id: 1,
        benefit_type_name: "E-coupon",
        os_id: null,
        voucher_validity_in_days: null,
        pts_multplier: null,
        payday_days: null
      });
    },
    removeExclusiveOfferFromSelected(idx) {
      if (!this.currentLevel) return;
      this.currentLevel.exclusiveOffers.splice(idx, 1);
    },
    addPaydayOffers() {
      if (!this.currentLevel) return;
      this.currentLevel.payday.push({
        benefit_section_type_id: 3,
        benefit_section_name: "Payday Benefits",
        visits: null,
        benefit_type_id: 1,
        benefit_type_name: "E-coupon",
        os_id: null,
        voucher_validity_in_days: null,
        pts_multplier: null,
        payday_days: null
      });
    },
    removePaydayOfferFromSelected(idx) {
      if (!this.currentLevel) return;
      this.currentLevel.payday.splice(idx, 1);
    },
    addBirthdayTreat() {
      if (!this.currentLevel) return;
      this.currentLevel.birthday.push({
        benefit_section_type_id: 4,
        benefit_section_name: "Birthday Benefits",
        visits: null,
        benefit_type_id: 1,
        benefit_type_name: "E-coupon",
        os_id: null,
        voucher_validity_in_days: null,
        pts_multplier: null,
        payday_days: null
      });
    },
    removeBirthdayTreatFromSelected(idx) {
      if (!this.currentLevel) return;
      this.currentLevel.birthday.splice(idx, 1);
    },
    onChangeVistBasedLevels(event) {
      console.log("onChangeVistBasedLevels", event);
      this.loyalty_levels.map(x => {
        x["points_required"] = null;
        x["visits"] = null;
        x["visit_within_days"] = null;
        x["visit_based_levels"] = event;
        x["amount_based_levels"] = "N";
      });
      this.$forceUpdate();
    },
    onChangeAmountBasedLevels(event) {
      console.log("onChangeAmountBasedLevels", event);
      this.loyalty_levels.map(x => {
        x["visits"] = null;
        x["visit_based_levels"] = "N";
        x["amount_based_levels"] = event;
      });
      this.$forceUpdate();
    },
    onSelectLevel(expiryId) {
      console.log("expiryId", expiryId);

      let params = this.expiryArray.find(x => x.expiry_id == expiryId);

      console.log("params", params);

      if (!params["show_input"]) {
        this.expiry_value = "";
      }
      this.selectedExpiry = params;
      this.expiry_rule = params["expiry_name"];
      this.expiry_type = params["expiry_id"];
    },
    addLoyaltySettings: function() {
      this.loyalty_levels.push({
        ll_name: `Level ${this.loyalty_levels.length + 1}`,
        visits: null,
        visit_within_days: null,
        points_required: null,
        multiple_points: null,
        bonus_points: null,
        ll_is_active: true,
        visit_based_levels: this.visit_based_levels,
        amount_based_levels: this.amount_based_levels,
        visitVouchers: [],
        exclusiveOffers: [],
        birthday: [],
        payday: []
      });
    },
    removeLoyaltySettings: function(index) {
      this.loyalty_levels.splice(index, 1);
    },
    validatePayload() {
      let errorMsg = ``;
      let errorLevelIndex = null;
      let errorCount = 0;

      if (!this.expiry_type) {
        errorCount++;
        errorMsg = `Please Select Expiry Rule`;
      } else if (!this.expiry_value && this.selectedExpiry["show_input"]) {
        errorCount++;
        errorMsg = `Please Enter Expiry Value`;
      }

      this.loyalty_levels.forEach((x, levelIndex) => {
        if (this.visit_based_levels == "Y") {
          if (isNaN(String(x["visits"]))) {
            errorCount++;
            errorMsg = `Please Enter Visits`;
          } else if (isNaN(String(x["visit_within_days"]))) {
            errorCount++;
            errorMsg = `Please Enter Days For Visits`;
          } else if (x["visit_based_levels"] == "N") {
            x["visit_based_levels"] = "Y";
          }
        } else if (this.amount_based_levels == "Y") {
          if (isNaN(String(x["points_required"]))) {
            errorCount++;
            errorMsg = `Please Enter Amount Required`;
          } else if (isNaN(String(x["visit_within_days"]))) {
            errorCount++;
            errorMsg = `Please Enter Days For Visits`;
          }
        } else if (this.visit_based_levels == "N") {
          if (isNaN(String(x["points_required"]))) {
            errorCount++;
            errorMsg = `Please Enter Points Required.`;
          }
        }

        if (x["visitVouchers"].length) {
          x["visitVouchers"].forEach(_visit_setting => {
            if (isNaN(String(_visit_setting["no_of_visits"]))) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Enter Visits In Additional Settings - ${x.ll_name}`;
            } else if (
              _visit_setting["benefit_type_id"] == 1 &&
              !_visit_setting.os_id
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Voucher - ${x.ll_name}`;
            } else if (
              _visit_setting["benefit_type_id"] == 2 &&
              isNaN(String(_visit_setting.pts_multplier))
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Pts Multiplier - ${x.ll_name}`;
            } else if (
              _visit_setting["benefit_type_id"] == 1 &&
              isNaN(String(_visit_setting.voucher_validity_in_days))
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Voucher Validity - ${x.ll_name}`;
            }
          });
        }

        if (x["exclusiveOffers"].length) {
          x["exclusiveOffers"].forEach(_visit_setting => {
            if (
              _visit_setting["benefit_type_id"] == 1 &&
              !_visit_setting.os_id
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Voucher - ${x.ll_name}`;
            } else if (
              _visit_setting["benefit_type_id"] == 1 &&
              isNaN(String(_visit_setting.voucher_validity_in_days))
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Voucher Validity - ${x.ll_name}`;
            }
          });
        }

        if (x["birthday"].length) {
          x["birthday"].forEach(_visit_setting => {
            if (
              _visit_setting["benefit_type_id"] == 1 &&
              !_visit_setting.os_id
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Voucher - ${x.ll_name}`;
            } else if (
              _visit_setting["benefit_type_id"] == 1 &&
              isNaN(String(_visit_setting.voucher_validity_in_days))
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Voucher Validity - ${x.ll_name}`;
            }
          });
        }

        if (x["payday"].length) {
          x["payday"].forEach(_visit_setting => {
            if (!_visit_setting["payday_days"]) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Enter Paydays - ${x.ll_name}`;
            } else if (
              _visit_setting["benefit_type_id"] == 1 &&
              !_visit_setting.os_id
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Voucher - ${x.ll_name}`;
            } else if (
              _visit_setting["benefit_type_id"] == 2 &&
              isNaN(String(_visit_setting.pts_multplier))
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Pts Multiplier - ${x.ll_name}`;
            } else if (
              _visit_setting["benefit_type_id"] == 1 &&
              isNaN(String(_visit_setting.voucher_validity_in_days))
            ) {
              errorCount++;
              errorLevelIndex = levelIndex;
              errorMsg = `Please Select Voucher Validity - ${x.ll_name}`;
            }
          });
        }
      });

      if (errorCount > 0) {
        this.$toasted.show(errorMsg);
        return false;
      } else {
        return true;
      }
    },
    GetDynamicVouchers: function() {
      MarketingService.GetDynamicVouchersList()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length) {
            this.voucherOptions = data.Records;
          } else {
            this.voucherOptions = [];
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    },
    getGloballoyaltysettingsBYID: function(id) {
      let payload = {
        ls_id: id
      };
      MarketingService.GetGlobalLoyaltySettingsBYID(payload).then(response => {
        const { data } = response;

        if (data.status) {
          let objls = data.loyalty_settings;

          this.ls_id = objls.ls_id;
          this.ls_name = objls.ls_name;
          this.expiry_rule = objls.expiry_rule;
          this.expiry_value = objls.expiry_value;
          this.expiry_type = objls.expiry_type;
          this.onSelectLevel(objls.expiry_type);
          // this.selectedExpiry = {
          //   expiry_id: objls.expiry_type,
          //   expiry_name: objls.expiry_rule
          // };
          this.lnitial_load = objls.lnitial_load;
          this.visit_based_levels = objls.visit_based_levels || "N";
          this.amount_based_levels = objls.amount_based_levels || "N";
          this.ls_is_active = objls.ls_is_active == "Y" ? true : false;

          this.loyalty_levels = data.loyalty_levels;
        }
      });
    },
    OnFinalSubmit: function() {
      this.submitted = true;
      let validationCheck = this.validatePayload();
      this.$validator.validate().then(valid => {
        if (this.expiry_rule.length == 0) {
          return;
        }
        if (valid && validationCheck) {
          let payload = {
            ls_id: this.ls_id,
            ls_name: this.ls_name,
            expiry_rule: this.expiry_rule,
            expiry_value: this.expiry_value,
            expiry_type: this.selectedExpiry["expiry_id"] || this.expiry_type,
            visit_based_levels: this.visit_based_levels || "N",
            amount_based_levels: this.amount_based_levels || "N",
            lnitial_load: this.lnitial_load,
            ls_is_active: this.ls_is_active,
            loyalty_levels: this.loyalty_levels
          };

          let serviceFunction = this.ls_id
            ? MarketingService.UpdateGlobalLoyaltySettingsBYID(payload)
            : MarketingService.AddGlobalLoyaltySettings(payload);

          serviceFunction
            .then(response => {
              this.btenable = false;

              const { data } = response;
              if (data.status) {
                this.submitted = false;
                this.$router.push({
                  path: "/marketing/global-loyalty-settings"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
      // this.btenable = true;
    }
  }
};
</script>
<style>
.offer-block {
  border: 1px solid #dee2e6;
  overflow: hidden;
}
.offer-block .border-end {
  border-color: #dee2e6 !important;
}
.table th,
.table td {
  vertical-align: middle;
}

.table-light th {
  color: #726e6e;
  /* color: #9f9f9f; */
  font-weight: 500;
  text-transform: uppercase;
  border: none !important;
  border-bottom: none !important;
}

.table-light thead th {
  border: none !important;
  border-bottom: none !important;
}

.table-loyalty td {
  border: none !important;
  border-top: none !important;
}

.minWidth {
  min-width: 100px;
}

.bg-light {
  background-color: #f8f9fa !important;
}
.level-pills button {
  white-space: nowrap;
}
.level-pills {
  gap: 8px;
}

.manual_bill_item .multiselect__tags {
  border-radius: unset !important;
  border: unset !important;
}

.manual_bill_input input {
  border: none;
  height: 40px;
  margin: 0;
  width: 100%;
  padding-inline: 10px;
}

.manual_bill_input input::placeholder,
.manual_bill_wrapper .multiselect__placeholder {
  font-size: 12px;
  font-style: italic;
}

.input_text-center input {
  text-align: center;
}

.input_text-right input {
  text-align: right;
}

.manual_bill_wrapper .multiselect__placeholder {
  font-weight: unset !important;
}

.noItemsClass {
  text-align: center;
  width: 100%;
  margin: 16px auto;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
}

.taxPopOver {
  zoom: 0.8;
  min-width: 200px;
}

.errRow {
  border: 2px solid red;
}
.borderNone {
  border: none !important;
}

.complete-tick {
  width: 120px;
  height: 120px;
  display: inline-block;
  background-size: contain;
}

.no_edit_allowed {
  cursor: not-allowed !important;
  opacity: 0.5;
}

.smallNote {
  font-size: 12px;
  color: #cc8989;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/LoyaltySettingsComponents/newLoyalityV2.vue